import { Text } from "@gcs/design-system/react";
import styled from "styled-components/macro";

export const Wrap = styled.section(({ theme }) => ({
  display: "grid",
  backgroundColor: theme.color.neutral["08"],
  padding: "40px 16px",
  gap: "60px",
  borderBottom: "1px solid #E3E0E2",

  [theme.breakpoint.xl()]: {
    padding: "112px 98px"
  }
}));

export const Content = styled.div(({ theme }) => ({
  [theme.breakpoint.lg()]: {
    marginRight: "74px"
  }
}));

export const Title = styled(Text)(({ theme }) => ({
  marginBottom: "32px",
  fontWeight: "700",
  fontSize: "32px",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.xl()]: {
    fontSize: "40px"
  },
}));

export const Paragraph = styled(Text)(({ theme }) => ({
  marginBottom: "32px",
  fontWeight: "500",
  fontSize: "18px",
  color: theme.color.neutral["02"],

  [theme.breakpoint.xl()]: {
    fontSize: "20px"
  },
}));

export const Image = styled.img(() => ({
  maxWidth: "100%",
  display: "block",
  margin: "0 auto"
}))

export const Link = styled.a(({ theme }) => ({

}))